
import { v4Url } from "~/services/public/Listing"

export const frConfig = {
  v2: {
    header_card_removals: "/publier-annonce/demenagement",
    header_card_furniture: "/publier-annonce/transport-marchandises-generales",
    footer_about_us: "/a-propos-de-nous",
    footer_contact_us: "/contactez-nous",
    nav_removals: "/demenagements",
    nav_removals_paris: "",
    nav_international: "/demenagement-europe",
    nav_furniture: "/transport-de-meubles",
    nav_van: "",
    nav_car: "/transport-de-vehicules",
    nav_motorcycle: "/transport-de-vehicules/transport-de-motos",
    nav_piano: "/piano-demenagement",
    nav_ebay: "/coursiers-ebay",
  },
  v4: {
    header_card_removals: "/fr/" + v4Url.preListing.houseMove,
    header_card_furniture: "/fr/" + v4Url.preListing.furniture,
    footer_about_us: "/fr/a-propos/",
    footer_contact_us: "/fr/nous-contacter/",
    nav_removals: "/fr/demenagement",
    nav_removals_paris: "/fr/demenagement-paris",
    nav_international: "/fr/demenagement-europe",
    nav_furniture: "/fr/transport-meubles",
    nav_van: "/fr/petit-demenagement",
    nav_car: "/fr/transport-voiture",
    nav_motorcycle: "/fr/transport-motos",
    nav_piano: "/fr/demenagement-piano",
    nav_ebay: "/fr/coursiers-ebay",
  }
}